import React, { useEffect, createElement, Component } from 'react';
// Función para inicializar el Meta Pixel
export const initializePixel = () => {
  // Verificamos si estamos en el navegador
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }
  // Verificamos si el objeto fbq ya existe
  if (!window.fbq) {
    window.fbq = function () {
      window.fbq.callMethod ? window.fbq.callMethod.apply(window.fbq, arguments) : window.fbq.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = window.fbq;
    window.fbq.push = window.fbq;
    window.fbq.loaded = true;
    window.fbq.version = '2.0';
    window.fbq.queue = [];
  }
  // Añadimos el script de Meta Pixel al documento de manera segura
  try {
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    // Comprobamos si hay elementos script en el documento
    const firstScript = document.getElementsByTagName('script')[0];
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    } else {
      // Si no hay scripts, añadimos al body o head como fallback
      const fallbackParent = document.body || document.head;
      if (fallbackParent) {
        fallbackParent.appendChild(script);
      }
    }
    // Inicializamos el pixel con el ID proporcionado
    window.fbq('init', '286333876857444');
  } catch (error) {
    console.error('Error al inicializar Meta Pixel:', error);
  }
};
// Evento de vista de página
export const trackPageView = () => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView');
  }
};
// Evento de visualización de contenido (producto)
export const trackViewContent = () => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'ViewContent', {
      content_name: 'Gorro Terapéutico RelaxGlow',
      content_category: 'Salud',
      content_ids: ['RELAXGLOW001'],
      content_type: 'product',
      value: 25.0,
      currency: 'USD'
    });
  }
};
// Evento de añadir al carrito
export const trackAddToCart = () => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Gorro Terapéutico RelaxGlow',
      content_category: 'Salud',
      content_ids: ['RELAXGLOW001'],
      content_type: 'product',
      value: 25.0,
      currency: 'USD'
    });
  }
};
// Evento de iniciar proceso de compra
export const trackInitiateCheckout = () => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'InitiateCheckout', {
      content_name: 'Gorro Terapéutico RelaxGlow',
      content_category: 'Salud',
      content_ids: ['RELAXGLOW001'],
      content_type: 'product',
      value: 25.0,
      currency: 'USD',
      num_items: 1
    });
  }
};
// Evento de compra completada
export const trackPurchase = () => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'Purchase', {
      content_name: 'Gorro Terapéutico RelaxGlow',
      content_category: 'Salud',
      content_ids: ['RELAXGLOW001'],
      content_type: 'product',
      value: 25.0,
      currency: 'USD',
      num_items: 1
    });
  }
};
// Componente que inicializa el pixel
export const MetaPixelProvider = ({
  children
}) => {
  useEffect(() => {
    try {
      // Inicializar el pixel
      initializePixel();
      // Registrar la vista de página
      trackPageView();
      // Registrar visualización de contenido (producto)
      trackViewContent();
    } catch (error) {
      console.error('Error en MetaPixelProvider:', error);
    }
  }, []);
  return <>{children}</>;
};
// Añadimos la declaración de tipos para TypeScript
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}